import {Survey} from '../../SurveyModels'

export interface SurveyValidatorResult {
  pageName?: string
  elementName?: string
  level: 'WARNING' | 'ERROR'
  description: string
  id?: string
}

export abstract class SurveyValidator {
  constructor(protected survey: Survey) {}

  abstract result(): Promise<SurveyValidatorResult[]>
}
